import React, { useRef } from 'react';
import styled from 'styled-components';
import { Sticky } from 'semantic-ui-react';
import { AccordionToggleButton, AccordionPanel } from '../Accordion';
import { CategoryHeader } from './CategoryHeader';
import { ToggleFooter } from './ToggleFooter';
import { FAQContent } from './FAQContent';
import media from '../../utils/media';
import 'semantic-ui-css/semantic.min.css';
const Container = styled.div `
  width: 100%;
  margin-bottom: 80px;

  .panel-container {
    width: calc(100% - 20px);
    margin: 0px 10px;

    ${media.mobile} {
      margin: 10px;
    }
  }

  .ui.fixed.sticky.top .category-header {
    box-shadow: 0 4px 6px -2px grey;
  }

  .ui.bound-container {
    opacity: 0;
  }
`;
export const AccordionGroup = ({ data, collapseText, expandText, questionCategoryTitle, isWindowMobile, openPanels, closePanels, isAllPanelsOpen, isPanelOpen, togglePanel, }) => {
    const ref = useRef(null);
    return (React.createElement(Container, { ref: ref },
        isWindowMobile ? (React.createElement(Sticky, { context: ref, offset: 51 },
            React.createElement(CategoryHeader, { collapseText: collapseText, expandText: expandText, questionCategoryTitle: questionCategoryTitle, openPanels: () => openPanels(data.map((_, index) => index)), closePanels: closePanels, isAllPanelsOpen: isAllPanelsOpen }))) : (React.createElement(CategoryHeader, { collapseText: collapseText, expandText: expandText, questionCategoryTitle: questionCategoryTitle, openPanels: () => openPanels(data.map((_, index) => index)), closePanels: closePanels, isAllPanelsOpen: isAllPanelsOpen })),
        data.map(({ fields: itemFields }, index) => {
            const { questionText, answerText, ctaLink, ctaLinkText, thumbnailImage, video } = itemFields;
            return (React.createElement(AccordionPanel, { key: index, isOpen: isPanelOpen(index), onToggle: () => togglePanel(index), renderToggleButtonAs: ({ isOpen, onToggle }) => (React.createElement(AccordionToggleButton, { isOpen: isOpen, onToggle: onToggle, heading: questionText.value, showDownArrow: !isWindowMobile })), renderToggleFooterAs: !isWindowMobile
                    ? () => null
                    : ({ isOpen, onToggle }) => React.createElement(ToggleFooter, { isOpen: isOpen, onToggle: onToggle }) },
                React.createElement(FAQContent, { answerText: answerText, ctaLink: ctaLink, ctaLinkText: ctaLinkText, thumbnailImage: thumbnailImage, video: video, allowContentToBeTabbable: isPanelOpen(index) })));
        })));
};
